import heartJackpotUrl from '../assets/lottie/effect/trh-full-heart-jackpot-finale.json?url';
import megaStarUrl from '../assets/lottie/effect/trh-full-mega-star-explosion.json?url';

export type LottieEffectLoader = () => Promise<unknown>;

const animationDataCache = new Map<string, Promise<unknown>>();

const loadLottieJson = (url: string) => {
    const cachedAnimationData = animationDataCache.get(url);

    if (cachedAnimationData) {
        return cachedAnimationData;
    }

    const animationData = fetch(url).then((response) => {
        if (!response.ok) {
            throw new Error(
                `Failed to load Lottie effect JSON: ${response.status} ${response.statusText}`
            );
        }

        return response.json();
    });

    animationDataCache.set(url, animationData);

    return animationData;
};

export const LOTTIE_EFFECT_TRIGGERS: Record<string, LottieEffectLoader> = {
    ':chat-lottie-effect-heart-jackpot': () => loadLottieJson(heartJackpotUrl),
    ':chat-lottie-effect-mega-star': () => loadLottieJson(megaStarUrl),
};

export const isChatLottieEffectTrigger = ({
    ch,
    message,
}: {
    ch?: boolean;
    message?: string;
}) =>
    Boolean(
        ch &&
            message &&
            Object.prototype.hasOwnProperty.call(
                LOTTIE_EFFECT_TRIGGERS,
                message
            )
    );
